import React, {useCallback} from 'react';
import Icon from '@chkp/ci-front-common-icons'
import SMCLabel from '../../../../components/Simple/SMCLabel';
import EditorLayout from '../../../../components/Layouts/EditorLayout';
import {PlanGetSchema} from '../../../../api/DBSchema/Plan';
import {useTranslation} from 'react-i18next';
import EmptyRow from '../../../../components/Simple/EmptyRow';
import SMCTextInput from '../../../../components/Simple/SMCTextInput';
import RowLayout from '../../../../components/Layouts/RowLayout';
import {SMCCheckbox} from '../../../../components/Simple/SMCCheckbox';
import SMCButton from '../../../../components/Simple/SMCButton';
import generateIcon from '../../../../assets/images/generate.png';
import {generateRandomString} from '../../../../utils/utils';

const pageSchema = PlanGetSchema.pages.gatewayActivation;
const pageId = pageSchema.pageId;

function PlanGatewayActivation({
    planObject,
    setPlanData
}) {
    const { t } = useTranslation();

    const pageData = planObject[pageId];
    const setPageValue = (paramName, value) => {
        setPlanData([pageId, paramName], value);
    }

    const connectAnonymously = pageData[pageSchema.connectAnonymously];
    const regKey             = pageData[pageSchema.regkey];
    const activationKey      = pageData[pageSchema.activationKey];

    const copyActivationKey = useCallback(() => {
        navigator.clipboard.writeText(activationKey);
    }, [activationKey]);

    return (
        <EditorLayout labelWidth={130}>
            <SMCCheckbox
                checked={connectAnonymously}
                onChange={e => setPageValue(pageSchema.connectAnonymously, e.target.checked)}
                label={t('SMP.PLAN.NEW_PLAN_GA.LINE1')}
            />
            <SMCLabel><b>{t('SMP.DESCRIPTION')}: </b>{t('SMP.PLAN.NEW_PLAN_GA.LINE2')}</SMCLabel>
            
            <EmptyRow />
            
            <RowLayout>
                <SMCTextInput
                    value={regKey}
                    onChange={e => setPageValue(pageSchema.regkey, e.target.value)}
                    disabled={!connectAnonymously}
                    label={t('SMP.PLAN.NEW_PLAN_GA.REG_KEY')}
                />
                <SMCButton disabled={!connectAnonymously} onClick={() => setPageValue(pageSchema.regkey, generateRandomString(8))}>
                    <img src={generateIcon} alt="Generate" />
                </SMCButton>
            </RowLayout>
            <RowLayout>
                <SMCTextInput
                    value={activationKey}
                    onChange={e => setPageValue(pageSchema.activationKey, e.target.value)}
                    disabled={!connectAnonymously}
                    width={350}
                    label={t('SMP.PLAN.NEW_PLAN_GA.ACTIVATION_KEY')}
                />
                <SMCButton tooltip="Copy"  onClick={copyActivationKey} style={{ height: 28, margin: 0 }}>
                    <Icon name={'copy'} width={15} height={15} />
                </SMCButton>
            </RowLayout>
            <EmptyRow />
            <SMCLabel>{t('SMP.PLAN.NEW_PLAN_GA.LINE3')}</SMCLabel>
        </EditorLayout>
    );
}

export default PlanGatewayActivation;